import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";

export default function AuthFailurePage() {
	const navigate = useNavigate();
	const location = useLocation();

	useEffect(() => {
		if (!location.state?.fromValidation) {
			navigate("/login", { replace: true });
		}
	}, [location, navigate]);

	if (!location.state?.fromValidation) {
		return null;
	}

	return (
		<main className="h-screen flex items-center justify-center overflow-auto p-8 bg-[#fafafa]">
			<div className="max-w-[960px] mx-auto text-center">
				<h1 className="text-2xl font-bold mb-4">Authentication Failed</h1>
				<p className="text-gray-600 mb-6">Your authentication link has expired or is invalid. Please request a new one.</p>
				<button onClick={() => navigate("/login")} className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
					Back to Login
				</button>
			</div>
		</main>
	);
}
